import { Credits } from '@/components/organisms/Admin/Mentors/Credits'
import { Hero } from '@/components/organisms/Admin/Mentors/Hero'
import { Mentoring } from '@/components/organisms/Admin/Mentors/Mentoring'

export function MentorsPage() {
	return (
		<div className='w-full relative z-10 min-h-[calc(100vh_-_81px)] overflow-clip'>
			<img
				src='/imgs/admin/grafismo.png'
				alt='Emoji'
				className='absolute z-0 opacity-60 lg:opacity-80 dark:opacity-40 dark:md:opacity-100 w-[75%] h-auto md:w-[50%] md:h-64 2lg:w-[877px] -top-20 2lg:h-[407px] -right-[127px] 2lg:-top-[207px]'
			/>
			<Mentoring />
			<Credits />
			<Hero />
		</div>
	)
}
